import logo from '../../../img/logo.svg';
import BackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

export default function Logo({onClose}){


    return <div className='study-logo'>

        <Link to="/enrollments">
            <BackIcon 
                sx={{color: 'white', cursor: 'pointer'}} 
            />
        </Link>

        <img src={logo} alt='Logo' width={200} height={45} />

        <div className='study-desktop-hidden'>
            <CloseIcon sx={{color: 'white', cursor: 'pointer'}} onClick={onClose} />
        </div>

    </div>
}